// extracted by mini-css-extract-plugin
export var avatarContainer = "_f0-0";
export var avatarTypingWave = "_f0-i";
export var gray = "_f0-f";
export var green = "_f0-c";
export var icon = "_f0-9";
export var image = "_f0-1";
export var lg = "_f0-6";
export var md = "_f0-5";
export var presenceDot = "_f0-b";
export var red = "_f0-d";
export var sm = "_f0-4";
export var status = "_f0-a";
export var typingDot = "_f0-h";
export var typingPill = "_f0-g";
export var xl = "_f0-7";
export var xs = "_f0-3";
export var xxl = "_f0-8";
export var xxs = "_f0-2";
export var yellow = "_f0-e";